
const digest = '408c1662e484ae0e93f54e5a57da493786d61a95be8b3f5b9ad8f8ee3a5e5c1b';
const css = `._embedInline_1gdfa_1 {
  display: inline-block;
  vertical-align: middle;
  margin: 0.5em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"embedInline":"_embedInline_1gdfa_1"};
export { css, digest };
  